import React, { useState, useCallback } from 'react';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import './style.scss';

interface StateProps {
  file: string | undefined | null;
  isBottom?: () => void;
  scale?: number;
}

//URLかどうか
const isUrl = (str: string) => {
  const pattern = new RegExp('/^https?://[w/:%#$&?()~.=+-]+$/');
  return !!pattern.test(str);
};

// ファイルがData URL形式かどうかをチェックする関数
const isLocalFile = (file: string): boolean => {
  return file.startsWith('/');
};

// ファイルがData URL形式かどうかをチェックする関数
const hasDataURL = (file: string): boolean => {
  return file.startsWith('data:application/pdf;base64,');
};

const isValidFileSource = (file: string): boolean => {
  return isUrl(file) || isLocalFile(file) || hasDataURL(file);
};

//pdf埋め込み
const PDFCanvasRenderViewer: React.FC<StateProps> = (props: StateProps) => {
  const { file, isBottom } = props;
  const [pages, setPages] = useState<JSX.Element[]>([]);

  // スケール値を調整する
  const getScale = () => {
    const width = window.innerWidth;
    if (width > 1200) return 1.7;
    else if (width > 850) return 1.25;
    else if (width > 500) return 1;
    return 0.7;
  };

  const onDocumentLoadSuccess = useCallback(({ numPages }: { numPages: number }) => {
    const pageList = Array.from(new Array(numPages), (_, index) => (
      <div key={`page_${index + 1}`} className="pdf-page-container">
        <Page pageNumber={index + 1} scale={getScale()} />
      </div>
    ));
    setPages(pageList);
  }, []);

  // スクロールイベントのハンドラ
  const handleScroll = useCallback(
    (event: React.UIEvent<HTMLDivElement>) => {
      const target = event.target as HTMLDivElement;
      if (target.scrollTop >= target.scrollHeight - target.clientHeight - 1 && isBottom) {
        isBottom();
      }
    },
    [isBottom],
  );

  if (file === undefined || file === null) {
    //エラー出力
    return;
  }

  return (
    <>
      <div
        className="pdf-container"
        style={{ margin: '0 auto', height: 600, overflowX: 'hidden', overflowY: 'scroll' }}
        onScroll={handleScroll}
      >
        <Document
          loading="読込中です..."
          file={isValidFileSource(file) ? file : 'data:application/pdf;base64,' + file}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          {pages}
        </Document>
      </div>
    </>
  );
};
export default PDFCanvasRenderViewer;
